import { Component, computed, input, OnInit, inject } from '@angular/core';
import { ControlContainer, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgClass, NgStyle } from '@angular/common';
import { QuestionItem } from '../../feedback-types';
import { radioDefaultValues } from '../../../../utils/feedback/feedback';

@Component({
  selector: 'app-feedback-radio-block',
  imports: [ReactiveFormsModule, NgClass, NgStyle],
  templateUrl: './feedback-radio-block.component.html',
  styleUrl: './feedback-radio-block.component.css',
})
export class FeedbackRadioBlockComponent implements OnInit {
  private controlContainer = inject(ControlContainer);

  public question = input.required<QuestionItem>();
  protected form!: FormGroup;
  protected values = computed(() => {
    const vals = this.question().values;
    return vals ? vals : radioDefaultValues;
  });

  ngOnInit(): void {
    this.form = this.controlContainer.control as FormGroup;
  }
}
